import React from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

import useAuth from 'hooks/useAuth';
import { FullScreenCard, Loading } from 'components/';
import ShowsProvider from 'providers/Shows';

import DashboardRoutes from './components/DashboardRoutes';
import AuthRoutes from './components/AuthRoutes';

const Routes: React.FC = () => {
  const { isLoading, isAuthenticated, doesAccountExist, token, tokenResolved } = useAuth();
  const { pathname } = useLocation();

  // Note: show loader if still loading and there is a token in the cache.
  //       If not token in cache, redirect to signin
  if (isLoading && (token !== '' || !tokenResolved)) {
    return (
      <FullScreenCard>
        <Loading message="Loading..." />
      </FullScreenCard>
    );
  } else if (pathname === '/' && isAuthenticated && doesAccountExist) {
    return <Redirect to="/links" />;
  }

  return (
    <Switch>
      <Route path={`/(signin|signup|reset)`} component={AuthRoutes} />
      <Route
        path={`/(settings|links)/:vanityUrl?`}
        render={() => (
          <ShowsProvider>
            <DashboardRoutes />
          </ShowsProvider>
        )}
      />
      <Redirect from="*" to="/signup" />
    </Switch>
  );
};

export default Routes;
